import React from 'react';
import { Text } from '@chakra-ui/react';

interface MaterialIconProps {
  iconName: string;
  fill?: number;
  size?: string;
  color?: string;
  verticalAlign?: string;
}

const MaterialIcon: React.FC<MaterialIconProps> = ({
  iconName,
  fill = 0,
  size,
  color,
  verticalAlign,
  ...props
}) => {
  return (
    <Text
      as="span"
      className="material-symbols-rounded"
      style={{ fontVariationSettings: `'FILL' ${fill}` }}
      {...(size && { fontSize: size })}
      {...(color && { color: color })}
      {...(verticalAlign && { verticalAlign: verticalAlign })}
      {...props}
    >
      {iconName}
    </Text>
  );
};

export default MaterialIcon;
